import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const uploadImage = createAsyncThunk(
    "upload/uploadImage",
    async (formData, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
            return rejectWithValue("Oturum bulunamadı.");
            }
            const headers = {
                Authorization: `Bearer ${token}`,
            };
            const response = await axios.post(`${API_URL}/upload/image`, formData,{
                headers: headers
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const uploadSlice = createSlice({
    name: "upload",
    initialState: {
        image: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetUpload: (state) => {
            state.image = null;
            state.loading = false;
            state.error = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadImage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(uploadImage.fulfilled, (state, action) => {
                state.loading = false;
                state.image = action.payload;
                state.error = null;
            })
            .addCase(uploadImage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});
export const { resetUpload, clearError } = uploadSlice.actions;

export default uploadSlice.reducer;